<div class="widget form-group" [class.has-error]="control.invalid">
  <input [attr.name]="name" type="hidden" [formControl]="control" />
  <label [attr.for]="id" class="horizontal control-label">
    {{ schema.title }}
    <sp-widget-tooltip [widget]="this"></sp-widget-tooltip>
  </label>
  <div [class.input-group]="prefix || suffix">
    <div class="input-group-addon" *ngIf="prefix">{{ prefix }}</div>
    <input readonly disabled
      class="text-widget textline-widget form-control" type="string"
      [attr.id]="id" [value]="value" [attr.placeholder]="schema.placeholder" />
    <div class="input-group-addon" *ngIf="suffix">{{ suffix }}</div>
  </div>
  <span *ngIf="schema.description" class="help-block">{{ schema.description }}</span>
  <sp-widget-error [widget]="this" [errors]="control.errors"></sp-widget-error>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/custom/durationdays.widget.html